import MapElement from './MapElement';
import FeatureDrawer from '../helpers/FeatureDrawer';
import FeatureStyle from '../helpers/FeatureStyles';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import DrawFunctions from '../helpers/DrawFunctions';

export default class MapSurveyViewer extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
    }

    drawLayer(data, projection) {
        var featureDrawer = new FeatureDrawer(projection, this.mapModel.projection);

        var features = [];
        var style = function (ft, res) { return FeatureStyle.customLineStyle(ft, ft, false, false) }
        var source = new VectorSource();
        this.layer = new VectorLayer({
            source: source,
            style: style,
        });

        console.log(data);
        for (const key in data) {
            const value = data[key];
            var polyLinePoints = [];
            var lastVertex = null;
            var vertexP = null;
            var prevBulge = 0;

            var arch_p1 = null
            var arch_q = null
            var arch_p2 = null

            if (value.length > 1) {
                for (let i = 0; i < value.length; i++) {
                    if (value[i].surveypositionId)
                        vertexP = value[i]
                    else
                        vertexP = { x: value[i].xspray, y: value[i].yspray };

                    //create bulge
                    if (vertexP.pointType === 2) {
                        if (arch_p1 == null) {
                            if (i > 0) {
                                arch_p1 = value[i - 1];
                                arch_q = vertexP;
                                continue; // dont push centre point point
                            } else {
                                arch_p1 = vertexP;
                            }
                        } else if (arch_q == null) {
                            arch_q = vertexP;
                            continue; //dont push centre point
                        } else {
                            arch_p2 = vertexP;
                            prevBulge = DrawFunctions.CreateBulgeFrom3Points(arch_p1.x, arch_p1.y, arch_q.x, arch_q.y, arch_p2.x, arch_p2.y);

                            var arch_p1 = null
                            var arch_q = null
                        }
                    }
                    else prevBulge = 0

                    polyLinePoints.push({ x: vertexP.x, y: vertexP.y });

                    if (prevBulge !== 0) {
                        polyLinePoints[polyLinePoints.length - 2].bulge = prevBulge
                    }
                }
                var feature = featureDrawer.drawFeature({ type: "POLYLINE", vertices: polyLinePoints });
                features.push(feature);
            } else {
                if (value[0].surveypositionId) vertexP = value[0]; // new survey
                else vertexP = { x: value[0].xspray, y: value[0].yspray }; // old survey

                var feature = featureDrawer.drawFeature({ type: "POINT", x: vertexP.x, y: vertexP.y });
                features.push(feature);
            }

        }

        source.addFeatures(features);

        this.parent.layer.getLayers().push(this.layer);

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }
}